<template>
    <div class="delivery-stats">
        <div class="delivery-stats__grid">
            <StatCard v-for="(stat, index) in stats" :key="index" :icon="stat.icon" :label="stat.label"
                :sublabel="stat.sublabel" :value="stat.value" :detail="stat.detail" :color="stat.color" applyBgColor
                applyBorderColor />
        </div>
    </div>
</template>

<script>
import StatCard from './StatCard.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'DeliveryStatsSection',
    components: {
        StatCard
    },
    computed: {
        ...mapGetters(['deliveryTimeStats']),
        stats() {
            const ts = this.deliveryTimeStats;
            return [
                {
                    icon: 'check_circle',
                    label: 'Entregados en el primer intento',
                    sublabel: 'Envíos completados sin necesidad de reintento',
                    value: ts ? ts.firstAttemptPct : 0,
                    detail: ts ? `${ts.firstAttempt} de ${ts.total}` : '0 de 0',
                    color: '#34C38F'
                },
                {
                    icon: 'schedule',
                    label: 'Antes de las 19:00',
                    sublabel: ts ? `${ts.before19} de ${ts.total} envíos` : '0 de 0 envíos',
                    value: ts ? ts.before19Pct : 0,
                    color: '#50A5F1'
                },
                {
                    icon: 'nights_stay',
                    label: 'Antes de las 22:00',
                    sublabel: ts ? `${ts.before22} de ${ts.total} envíos` : '0 de 0 envíos',
                    value: ts ? ts.before22Pct : 0,
                    color: '#F1B44C'
                }
            ]
        }
    }
}
</script>

<style scoped>
.delivery-stats__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
}

.section-title__text {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 1rem;
}

@media (max-width: 768px) {
    .delivery-stats__grid {
        grid-template-columns: 1fr;
    }
}
</style>
